import React from 'react'
import Routes from './routes'
import { Provider } from 'react-redux'
import configureStore from './redux/configureStore'

import 'react-dates/lib/css/_datepicker.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'

const store = configureStore()

const App = () => {

  return (
    <div className='App'>
      <Provider store={store}>
        <Routes />
      </Provider>
    </div>
  )
}

export default App
